module.exports = __webpack_public_path__ + "static/VideoCallJulian_Comp-fe390bdefff2982c0ebef19775b50cb1.mp4";